import { ClubSubscriptionEnum } from '../_generated/openapi';

export interface ClubSettings {
  basketball: {
    functions: {
      coach_presence: boolean;
      car_reservations: boolean;
    };
    season_planer: {
      visible_tasks: number[];
    };
  };
  general: {
    functions: {
      partners: boolean;
    };
  };
}

export interface ClubSubscription {
  active: ClubSubscriptionEnum;
  limits: {
    users: number;
    basketball_teams: number;
    tasks: number;
  };
}

export const ClubSubscriptionType = {
  FREE: 'free' as ClubSubscriptionEnum,
  FIRST: 'first' as ClubSubscriptionEnum,
  SECOND: 'second' as ClubSubscriptionEnum,
  THIRD: 'third' as ClubSubscriptionEnum,
  FOURTH: 'fourth' as ClubSubscriptionEnum,
};

export type GeneralClubSettingFunctionTypeEnum = 'partners';
export type BasketballClubSettingFunctionTypeEnum = 'car_reservations';

export const GeneralClubSettingFunctionType = {
  PARTNERS: 'partners' as GeneralClubSettingFunctionTypeEnum,
};

export const BasketballClubSettingFunctionType = {
  CAR_RESERVATIONS: 'car_reservations' as BasketballClubSettingFunctionTypeEnum,
};
